const pagesLaborCoreSettingsEn = {
  applicantContacts: {
    actions: {
      edit: 'Edit',
      viewDetails: 'View Details'
    },
    addButton: 'Add Applicant & Contact',
    createSuccess: 'Profile created successfully',
    default: 'Default',
    description: 'You can pre-configure information to be used for electronic applications.',
    dialog: {
      addTitle: 'Add Applicant & Contact',
      cancel: 'Cancel',
      create: 'Create',
      creating: 'Creating...',
      editTitle: 'Edit Applicant & Contact',
      profileName: 'Profile Name',
      profileNamePlaceholder: 'Enter profile name',
      setAsDefault: 'Set as default',
      setAsDefaultDescription: 'This profile will be selected by default when creating new applications'
    },
    title: 'Applicant & Contact Information',
    updateSuccess: 'Profile updated successfully'
  },
  callback: {
    connectionComplete: 'Successfully connected with e-Gov',
    connectionFailed: 'e-Gov authentication failed',
    invalidAuthInfo: 'Invalid authentication information. Please start the connection again.',
    sessionNotFound: 'Session information not found. Please start the connection again.'
  },
  certificate: {
    dialog: {
      cancel: 'Cancel',
      fileSelectError: 'Failed to select file',
      invalidFileType: 'Unsupported file format (only .p12, .pfx)',
      pin: 'PIN (Password)',
      pinPlaceholder: 'Enter certificate PIN',
      supportedFormats: 'Supported formats: .p12, .pfx',
      title: 'Upload Electronic Certificate',
      uploadButton: 'Upload',
      uploading: 'Uploading...'
    },
    expiringSoon: 'Expiring soon',
    fileName: 'File Name',
    issuer: 'Issuer',
    noCertificate: 'No certificate uploaded',
    subject: 'Subject',
    title: 'Electronic Certificate',
    update: 'Update',
    upload: 'Upload',
    uploadSuccess: 'Certificate uploaded successfully',
    validTo: 'Valid Until'
  },
  eGovAccount: {
    accountType: 'Account Type',
    connect: 'Connect',
    email: 'Email Address',
    logout: 'Logout',
    logoutSuccess: 'Successfully logged out from e-Gov',
    notConnected: 'e-Gov account is not connected',
    providerType: 'Provider',
    reconnect: 'Reconnect',
    title: 'e-Gov Account Information'
  },
  profileDetail: {
    breadcrumbs: {
      laborCore: 'Labor Core',
      settings: 'Settings'
    },
    error: {
      loadFailed: 'Failed to load data',
      noData: 'Data not found',
      unknownError: 'An unknown error occurred'
    },
    navigation: {
      applicantInformation: 'Applicant Information',
      certificate: 'Electronic Certificate',
      contactInformation: 'Contact Information',
      eGovAccount: 'e-Gov Account Information'
    },
    toast: {
      applicantUpdated: 'Applicant information updated successfully',
      contactUpdated: 'Contact information updated successfully'
    }
  },
  validation: {
    required: '{{field}} is required'
  }
};
export default pagesLaborCoreSettingsEn;